import common from './fr/common';
import auth from './fr/auth';
import home from './fr/home';
import navBar from './fr/navBar';
import projet from './fr/projet';
import parametre from './fr/parametre';
import logs from './fr/logs';
import database from './fr/database';
import maps from './fr/map';
import user from './fr/user';
import form from './fr/form';
import customer from './fr/customer';
import meterPlace from './fr/meterPlace';

export default {
  ...common,
  ...auth,
  ...home,
  ...navBar,
  ...projet,
  ...parametre,
  ...logs,
  ...database,
  ...maps,
  ...user,
  ...form,
  ...customer,
  ...meterPlace,
};
